import { useQuery } from '@tanstack/react-query'
import { baseURL, STALE_TIME } from '@/v2/constants/requests'

export const useUser = ({ enabled = true } = {}) => {
  const { data, isLoading, isError } = useQuery({
    queryKey: ['User'],
    queryFn: async () => {
      const res = await fetch(`${baseURL}/v2/rest/user.json`)
      if (!res.ok) {
        throw new Error('We could not find the logged user')
      }
      return res.json()
    },
    staleTime: STALE_TIME,
    enabled,
  })

  const isDashboardOnly =
    Array.isArray(data?.roles) &&
    data.roles.length === 1 &&
    data.roles[0] === 'dashboard'

  return { user: data, isLoading, isError, isDashboardOnly }
}
